/**
 * Where a feed card reads its frame: the frames store (the current project,
 * live through its websocket), then Everything's map of other projects'
 * frames (`stores/wall-scope-store.ts`). One subscription per card and
 * store, each to its own id.
 */
import type { FrameData } from "@/lib/frame-data";
import { useFramesStore } from "@/stores/frames-store";
import { useWallScopeStore } from "@/stores/wall-scope-store";

export function useWallFrame(
  id: string | null | undefined,
): FrameData | undefined {
  const own = useFramesStore((state) =>
    id ? state.framesById[id] : undefined,
  );
  const foreign = useWallScopeStore((state) =>
    id ? state.foreignFramesById[id] : undefined,
  );
  return own ?? foreign;
}

/** `useWallFrame` read once, outside render. */
export function wallFrame(id: string): FrameData | undefined {
  return (
    useFramesStore.getState().framesById[id] ??
    useWallScopeStore.getState().foreignFramesById[id]
  );
}
